import { render, staticRenderFns } from "./MyHead.vue?vue&type=template&id=8cb238f0&"
import script from "./MyHead.vue?vue&type=script&lang=js&"
export * from "./MyHead.vue?vue&type=script&lang=js&"
import style0 from "./MyHead.vue?vue&type=style&index=0&id=8cb238f0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports